import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { useScrollEffect } from "supercell-frontend-base/src/utils/on-scroll-effect";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

import { getProps } from "./get-props";

import { EsportArticleView } from "./view";
import { dim } from "../../article/controller";

type Params = { id: string; variant?: string; slug?: string };

export const EsportArticleController = () => {
    const { pathname: pagePath } = useLocation();
    const { id, variant, slug } = useParams<Params>();
    const { trackPageView } = useSnowplowContext();

    const isolated =
        (variant && variant.toLowerCase() === "isolated") ||
        (slug && slug.toLowerCase() === "isolated");

    useScrollEffect(dim);

    const track = (article) => {
        trackPageView(article?.title ?? "", pagePath);
    };

    const props = {
        getProps: getProps(id ?? "", Boolean(isolated)),
        id,
        track,
    };

    return <EsportArticleView {...props} />;
};
